import { render } from "./BaseCharts.vue?vue&type=template&id=3d574858&scoped=true"
import script from "./BaseCharts.vue?vue&type=script&lang=js"
export * from "./BaseCharts.vue?vue&type=script&lang=js"

import "./BaseCharts.vue?vue&type=style&index=0&id=3d574858&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d574858"

export default script